import { validate as isUUID } from 'uuid'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { VerticalDotsIcon } from '@/components/icons/VerticalDotsIcon'
import { DeleteThemeButton } from './DeleteThemeButton'
import { UpdateThemeButton } from './UpdateThemeButton'
import { SetDefaultThemeButton } from './SetDefaultThemeButton'

export const TemplatePreviewActionsDropdown = ({
  documentPageId,
  documentPageThemeId,
  themeName,
  isBuiltIn,
}: {
  documentPageId?: string | null
  documentPageThemeId?: string | null
  themeName?: string | null
  isBuiltIn?: boolean
}) => {
  const canUpdate = !isBuiltIn
  const canDelete = !isBuiltIn

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className="h-auto px-2 py-1 rounded-md bg-transparent hover:bg-zinc-100"
        onClick={(event) => {
          event.stopPropagation()
        }}
      >
        <VerticalDotsIcon className="w-3 h-3 stroke-gray-800" />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="z-[100]">
        {documentPageThemeId && (
          <SetDefaultThemeButton documentPageThemeId={documentPageThemeId} />
        )}
        {canUpdate &&
          documentPageId &&
          isUUID(documentPageId) &&
          documentPageThemeId &&
          themeName && (
            <UpdateThemeButton
              documentPageId={documentPageId}
              documentPageThemeId={documentPageThemeId}
              themeName={themeName}
            />
          )}

        {canDelete && documentPageThemeId && (
          <DeleteThemeButton documentPageThemeId={documentPageThemeId} />
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
